import { Button, BUTTON_TYPES } from '../../../components/Button'
import { BTN_TXT } from '../../../constants'
import './../styles.scss'
import { Typography, TYPOGRAPHY_WEIGHT } from '../../../components/Typography'
import { ReactComponent as Trailing } from 'assets/svg/Trailing.svg'
import { useSelector } from 'react-redux'
import { getUser } from '../../../redux/store/user/getters'
import { useCallback, useMemo, useState } from 'react'
import useRouter from '../../../hooks/useRouter'
import { routes } from '../../../router'
import { ROLES } from '../../Permission'
import { Tooltip } from '../../../components/Tooltip/Tooltip'
import cn from 'classnames'

export const QuickNavigationBlock = ({
  outsideCommunityMode
}: {
  outsideCommunityMode?: boolean
}) => {
  const user = useSelector(getUser)
  const { navigate } = useRouter()

  const isHospitalNavigation = useMemo(
    () => user.role === ROLES.HOSPITAL_ADMIN,
    [user.role]
  )

  const hospitalUserView = user.role === ROLES.HOSPITAL_USER

  const onNavigate = useCallback(() => {
    if (isHospitalNavigation) {
      navigate(
        outsideCommunityMode
          ? `${routes.myCommunity}${routes.myOrganization}${routes.hospitals}/${user.hospital}`
          : `${routes.myCommunity}${routes.myOrganization}${routes.healthSystems}/${user.health_system}${routes.hospitals}/${user.hospital}`
      )
    } else if (user.health_system)
      navigate(
        `${routes.myCommunity}${routes.myOrganization}${routes.healthSystems}/${user.health_system}`
      )
  }, [isHospitalNavigation, user, navigate, outsideCommunityMode])
  return (
    <div
      className={cn('p-16 column gap-16 quick-navigation', {
        'hospital-user-view': hospitalUserView
      })}
    >
      <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
        Quick access
      </Typography.Headline6>
      {hospitalUserView ? (
        <HospitalUserNavigation outsideCommunityMode={outsideCommunityMode} />
      ) : (
        <Button
          type={BUTTON_TYPES.DEFAULT}
          upperCase
          className="quick-navigation__reverse-btn"
          icon={<Trailing />}
          onClick={onNavigate}
        >
          <div>
            {isHospitalNavigation
              ? BTN_TXT.MY_HOSPITAL
              : BTN_TXT.MY_HEALTH_SYSTEM}
          </div>
        </Button>
      )}
    </div>
  )
}

const HospitalUserNavigation = ({
  outsideCommunityMode
}: {
  outsideCommunityMode?: boolean
}) => {
  const { hospitals, health_system } = useSelector(getUser)
  const { navigate } = useRouter()

  const [showAll, setShowAll] = useState<boolean>(false)

  const onNavigate = useCallback(
    (uuid: string) => {
      navigate(
        outsideCommunityMode
          ? `${routes.myCommunity}${routes.myOrganization}${routes.hospitals}/${uuid}`
          : `${routes.myCommunity}${routes.myOrganization}${routes.healthSystems}/${health_system}${routes.hospitals}/${uuid}`
      )
    },
    [health_system, navigate, outsideCommunityMode]
  )

  const showMoreButtonVisible = useMemo(
    () => Number(hospitals?.length) > 4,
    [hospitals]
  )

  const showMore = useCallback(() => setShowAll(!showAll), [showAll])

  return (
    <div className="column gap-8">
      {hospitals?.map((hospital, index) =>
        !showMoreButtonVisible || showAll || index < 2 ? (
          <Tooltip title={hospital.name}>
            <Button
              className="row space-between quick-navigation__btn"
              type={BUTTON_TYPES.DEFAULT}
              onClick={() => onNavigate(hospital.hospital)}
            >
              <div className="text-ellipsis">{hospital.name}</div>

              <Trailing />
            </Button>
          </Tooltip>
        ) : null
      )}
      {showMoreButtonVisible && (
        <div className="row justify-center" onClick={showMore}>
          <Typography.Caption
            weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}
            className="common-response-wrapper__more"
          >
            {showAll ? 'Show less' : `Show all ${hospitals?.length} hospitals`}
          </Typography.Caption>
        </div>
      )}
    </div>
  )
}
